import { Directive, effect, inject, input, TemplateRef, ViewContainerRef } from '@angular/core';

import { FeatureFlag } from '../models/feature-flag.enum';
import { FeatureFlagService } from '../services/feature-flag.service';

@Directive({
  standalone: true,
  selector: '[featureFlag]'
})
export class FeatureFlagDirective {
  featureFlag = input.required<FeatureFlag>();
  featureFlagElse = input<TemplateRef<unknown>>();

  private templateRef = inject(TemplateRef<unknown>);
  private viewContainer = inject(ViewContainerRef);
  private featureFlagService = inject(FeatureFlagService);

  private hasView = false;

  constructor() {
    effect(() => {
      const flag = this.featureFlag();
      const isEnabled = this.featureFlagService.isEnabled$(flag)();

      if (isEnabled && !this.hasView) {
        this.viewContainer.clear();
        this.viewContainer.createEmbeddedView(this.templateRef);
        this.hasView = true;
      } else if (!isEnabled && this.hasView) {
        this.viewContainer.clear();
        this.hasView = false;

        const elseTemplate = this.featureFlagElse();
        if (elseTemplate) {
          this.viewContainer.createEmbeddedView(elseTemplate);
        }
      } else if (!isEnabled && !this.hasView) {
        this.viewContainer.clear();

        const elseTemplate = this.featureFlagElse();
        if (elseTemplate) {
          this.viewContainer.createEmbeddedView(elseTemplate);
        }
      }
    });
  }
}
